import { boolean, integer, jsonb, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getTimestampWithTimezone,
} from '../common/utils'

export type SlotBreakdown = {
  today: number
  tomorrow: number
  in2Days: number
  in3Days: number
  in4PlusDays: number
}

export const bookingAnalytics = pgTable(
  'booking_analytics',
  {
    ...getBaseFields(),
    street: text().notNull(),
    postalCode: text(),
    city: text(),
    servicePresetKey: text(),
    presetFormValue: jsonb(),
    // Who ran the search. Staff searches (ERP slot picker, calling-campaign
    // preview) are not inbound demand, and the dashboard's "no slots found"
    // metric only means anything if they're excluded. Rows written before
    // this column existed are NULL and counted as customer searches, which
    // is what they overwhelmingly were.
    source: text().$type<'customer' | 'staff'>(),
    durationMinutes: integer().notNull(),
    slotsFound: integer().notNull(),
    earliestSlotTime: getTimestampWithTimezone(),
    latestSlotTime: getTimestampWithTimezone(),
    uniqueEmployees: integer().notNull().default(0),
    slotBreakdown: jsonb().$type<SlotBreakdown>(),
    // A/B test the search came from, e.g. 'iv-hinta:a'. NULL when no test was
    // running. The booking side of the funnel carries the same value on visits.
    experiment: text(),
    // The times came from empty days moved to a flex area, the search's last
    // fallback for a customer nothing else could serve.
    flexAreaSeeded: boolean().notNull().default(false),
  },
  (table) => getBaseIndexes('booking_analytics', table),
)
